var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_30646_21346",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 81
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_30646_21346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0833 72.1668C22.425 72.1668 20.1633 71.234 18.2983 69.3685C16.4328 67.5035 15.5 65.2418 15.5 62.5835V19.0577C15.5 16.2288 16.4969 13.8177 18.4908 11.8243C20.4842 9.83044 22.8953 8.8335 25.7242 8.8335H60.6925C62.0169 8.8335 63.1494 9.30349 64.09 10.2435C65.03 11.1841 65.5 12.3166 65.5 13.641V55.1477C65.5 55.541 65.3739 55.8979 65.1217 56.2185C64.8694 56.5385 64.5639 56.7671 64.205 56.9043C62.9872 57.2843 62.0331 57.999 61.3425 59.0485C60.6525 60.0974 60.3075 61.2757 60.3075 62.5835C60.3075 63.8357 60.6525 64.9863 61.3425 66.0352C62.0331 67.0846 62.9767 67.8102 64.1733 68.2118C64.6217 68.3696 64.955 68.6485 65.1733 69.0485C65.3911 69.4479 65.5 69.889 65.5 70.3718V70.276C65.5 70.7927 65.3225 71.2371 64.9675 71.6093C64.6131 71.981 64.1603 72.1668 63.6092 72.1668H25.0833ZM35.5575 37.8527H45.3592L47.0258 42.4235C47.1369 42.7479 47.3186 42.9999 47.5708 43.1793C47.8225 43.3588 48.1281 43.4485 48.4875 43.4485C49.0469 43.4485 49.4839 43.2191 49.7983 42.7602C50.1122 42.3007 50.1622 41.8188 49.9483 41.3143L42.6792 21.9743C42.5681 21.6282 42.3672 21.3602 42.0767 21.1702C41.7861 20.9802 41.4508 20.8852 41.0708 20.8852H39.795C39.4144 20.8852 39.0789 20.9802 38.7883 21.1702C38.4978 21.3602 38.2969 21.6282 38.1858 21.9743L30.9167 41.3335C30.7028 41.859 30.7617 42.3429 31.0933 42.7852C31.4244 43.2274 31.8697 43.4485 32.4292 43.4485C32.7886 43.4485 33.0942 43.3588 33.3458 43.1793C33.5981 42.9999 33.7797 42.7479 33.8908 42.4235L35.5575 37.8527ZM36.5958 34.8852L40.3975 24.4485H40.5517L44.2692 34.8852H36.5958ZM25.0833 68.3843H58.4292C57.8225 67.5938 57.3536 66.6985 57.0225 65.6985C56.6914 64.6985 56.5258 63.6602 56.5258 62.5835C56.5258 61.4724 56.6914 60.4254 57.0225 59.4427C57.3536 58.4593 57.8397 57.5724 58.4808 56.7818H25.0833C23.4722 56.7818 22.1025 57.346 20.9742 58.4743C19.8464 59.6027 19.2825 60.9724 19.2825 62.5835C19.2825 64.1946 19.8464 65.5643 20.9742 66.6927C22.1025 67.8204 23.4722 68.3843 25.0833 68.3843Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook3);
export default __webpack_public_path__ + "static/media/book_3.237d8c7e28d07bb7b2fbb9e0a2ae88e3.svg";
export { ForwardRef as ReactComponent };